/* 笠利店ページ：ヒーロー切り替え / 営業中表示 / スクロール演出 / PICK UP / EXPERIENCE */
(function () {
  var root = document.querySelector('[data-kk]');
  if (!root) return;
  var reduce = false; // デザインどおり、動きは常に有効にする
  var seen = false;
  try { seen = !!sessionStorage.getItem('kyora-opened'); sessionStorage.setItem('kyora-opened', '1'); } catch (e) {}
  var op = root.querySelector('[data-kk-opening]');
  if (op) { if (seen) op.remove(); else setTimeout(function () { op.remove(); }, 3800); } // 演出後はDOMごと外す（SVGフィルターの再描画を止める）

  /* ---- ヘッダー ---- */
  var hdr = root.querySelector('[data-kk-header]'), burger = root.querySelector('[data-kk-burger]'), drawer = root.querySelector('[data-kk-drawer]'), bl = root.querySelector('[data-kk-burger-label]');
  function onScroll() { if (hdr) hdr.classList.toggle('is-scrolled', window.scrollY > 80); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  function setMenu(open) { if (!drawer) return; drawer.classList.toggle('is-open', open); burger.setAttribute('aria-expanded', open ? 'true' : 'false'); bl.textContent = open ? 'CLOSE' : 'MENU'; }
  if (burger) burger.addEventListener('click', function () { setMenu(!drawer.classList.contains('is-open')); });
  [].forEach.call(root.querySelectorAll('[data-kk-close]'), function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  var top = root.querySelector('[data-kk-top]');
  if (top) top.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

  /* ---- ヒーロー ---- */
  var slides = [].slice.call(root.querySelectorAll('[data-kk-slide]'));
  var thumbs = [].slice.call(root.querySelectorAll('[data-kk-thumb]'));
  var cur = 0, timer = null, started = false;
  function show(i) {
    if (i === cur && started) return;
    var prev = cur; cur = i;
    slides.forEach(function (s, k) {
      s.classList.remove('is-prev', 'is-wipe', 'is-active');
      if (k === prev) s.classList.add('is-prev');
    });
    var next = slides[i];
    next.classList.remove('is-prev');
    // クリップを初期位置に戻してから表示（ワイプ演出）
    void next.offsetWidth;
    if (started) next.classList.add('is-wipe');
    next.classList.add('is-active');
    thumbs.forEach(function (t, k) {
      t.classList.remove('is-active');
      if (k === i) { void t.offsetWidth; t.classList.add('is-active'); }
    });
  }
  function start() {
    if (slides.length < 2 || reduce) return;
    clearInterval(timer);
    timer = setInterval(function () { if (heroOn) show((cur + 1) % slides.length); }, 6000);
  }
  // Googleマップは重いので、スマホ（タップ操作の端末）では押したときに初めて読み込む。PCは近くまで来たら読み込む
  var touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var loadMap = function (f) { if (f && !f.src && f.getAttribute('data-src')) f.src = f.getAttribute('data-src'); };
  [].forEach.call(root.querySelectorAll('[data-kk-maptap]'), function (b) {
    b.addEventListener('click', function () { b.parentNode.classList.add('is-active'); loadMap(b.parentNode.querySelector('iframe')); });
  });
  [].forEach.call(root.querySelectorAll('iframe[data-src]'), function (f) {
    if (touchOnly) return;
    if ('IntersectionObserver' in window) {
      var mio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { loadMap(f); mio.disconnect(); } }, { rootMargin: '400px' });
      mio.observe(f);
    } else loadMap(f);
  });
  // ヒーローが画面外のときは自動切り替えを止める（スクロール中の再描画を減らす）
  var heroEl = root.querySelector('[data-kk-hero]'), heroOn = true;
  if (heroEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { heroOn = es[0].isIntersecting; }, { threshold: 0.05 }).observe(heroEl);
  }
  if (slides.length) {
    slides[0].classList.add('is-active');
    setTimeout(function () { started = true; start(); }, seen ? 1200 : 3000);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { started = true; show(+t.getAttribute('data-kk-thumb')); start(); });
    });
  }

  /* ---- 営業中表示（日本時間） ---- */
  var timeEl = root.querySelector('[data-kk-time]'), stateEl = root.querySelector('[data-kk-state]');
  function toMin(v, d) { var m = /^(\d{1,2}):(\d{2})$/.exec(v || ''); return m ? (+m[1]) * 60 + (+m[2]) : d; }
  function tick() {
    if (!timeEl || !stateEl) return;
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Tokyo', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var g = function (t) { return p.filter(function (x) { return x.type === t; })[0].value; };
      var h = (+g('hour')) % 24, m = +g('minute');
      var wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(g('weekday'));
      var min = h * 60 + m;
      var open = String(wd) !== root.getAttribute('data-closed') && min >= toMin(root.getAttribute('data-open'), 660) && min < toMin(root.getAttribute('data-close'), 1050);
      timeEl.textContent = ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2);
      stateEl.textContent = open ? 'OPEN — 営業中' : 'CLOSED — 営業時間外';
    } catch (e) { timeEl.textContent = ''; stateEl.textContent = ''; }
  }
  tick(); setInterval(tick, 30000);

  /* ---- スクロールで現れる ---- */
  var targets = [].slice.call(root.querySelectorAll('[data-kk-reveal]'));
  if (!reduce && 'IntersectionObserver' in window && targets.length) {
    root.classList.add('is-js');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
    // 念のため：5秒後に未表示のものがあれば表示
    setTimeout(function () { targets.forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  /* ---- PICK UP ---- */
  var track = root.querySelector('[data-kk-track]');
  [].forEach.call(root.querySelectorAll('[data-kk-pick]'), function (b) {
    b.addEventListener('click', function () { if (track) track.scrollBy({ left: (+b.getAttribute('data-kk-pick')) * 372, behavior: reduce ? 'auto' : 'smooth' }); });
  });

  /* ---- EXPERIENCE ---- */
  var areaBtns = [].slice.call(root.querySelectorAll('[data-kk-area]'));
  var dataEl = root.querySelector('[data-kk-areas-data]');
  var areaData = []; try { areaData = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
  var no = root.querySelector('[data-kk-cur-no]'), nm = root.querySelector('[data-kk-cur-name]'), tx = root.querySelector('[data-kk-cur-text]');
  areaBtns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      areaBtns.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      var wrap = b.parentNode; if (wrap && wrap.scrollWidth > wrap.clientWidth + 2) wrap.scrollTo({ left: b.offsetLeft - (wrap.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
      if (areaData[i]) { no.textContent = ('0' + (i + 1)).slice(-2); nm.textContent = areaData[i].name; tx.textContent = areaData[i].text; }
    });
  });

  /* ---- MENU：見ているカテゴリに合わせて、ナビの強調と左の写真を切り替える ---- */
  var cats = [].slice.call(root.querySelectorAll('[data-kk-cat]'));
  if (cats.length && 'IntersectionObserver' in window) {
    var links = [].slice.call(root.querySelectorAll('[data-kk-catlink]')), sides = [].slice.call(root.querySelectorAll('[data-kk-side]'));
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var id = e.target.getAttribute('data-kk-cat');
        links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-kk-catlink') === id); });
        sides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-kk-side') === id); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    cats.forEach(function (c) { cio.observe(c); });
  }

  /* ---- TOPICS：カテゴリで絞り込む ---- */
  var fbtns = [].slice.call(root.querySelectorAll('[data-kk-filter]'));
  if (fbtns.length) {
    var tcards = [].slice.call(root.querySelectorAll('[data-kk-cat-of]')), empty = root.querySelector('[data-kk-empty]');
    fbtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-kk-filter'), shown = 0;
        fbtns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        tcards.forEach(function (c) { var ok = f === 'ALL' || c.getAttribute('data-kk-cat-of') === f; c.hidden = !ok; if (ok) shown++; });
        if (empty) empty.hidden = shown > 0;
      });
    });
  }

  /* ---- TOPICS：一覧と詳細を同じページで切り替える(?id=○○) ---- */
  var tlist = root.querySelector('[data-kk-topics-list]'), details = [].slice.call(root.querySelectorAll('[data-kk-detail]'));
  if (tlist && details.length) {
    var crumb = root.querySelector('[data-kk-crumb]'), crumbHtml = crumb ? crumb.innerHTML : '', baseTitle = document.title, basePath = location.pathname;
    var showTopic = function (id) {
      var hit = null;
      details.forEach(function (d) { var on = d.getAttribute('data-kk-detail') === id; d.hidden = !on; if (on) hit = d; });
      tlist.hidden = !!hit;
      if (crumb) crumb.innerHTML = hit ? '<a href="/pages/kasari">TOP</a><span>/</span><a href="' + basePath + '" data-kk-back>TOPICS</a><span>/</span><span class="is-cur">' + hit.getAttribute('data-kk-cat') + '</span>' : crumbHtml;
      document.title = hit ? hit.getAttribute('data-kk-title') + '｜' + baseTitle.split('–').pop().trim() : baseTitle;
    };
    var idOf = function () { try { return new URLSearchParams(location.search).get('id') || ''; } catch (e) { return ''; } };
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-kk-open],[data-kk-back]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var id = a.getAttribute('data-kk-open') || '';
      history.pushState({}, '', id ? basePath + '?id=' + encodeURIComponent(id) : basePath);
      showTopic(id); window.scrollTo({ top: 0, behavior: 'auto' });
    });
    window.addEventListener('popstate', function () { showTopic(idOf()); });
    showTopic(idOf());
  }
})();
